export default __webpack_public_path__ + "static/media/Fraunhofer-DarkModeSpheres_masked.0625f1a6.jpg";